import * as Yup from "yup";

export interface Product {
  name: string;
  quantity: number;
  price: number;
  id: number;
}

export interface InitialValuesProps {
  name: string;
  email: string;
  cpf: string;
  store: string;
  phone: string;
  birthDate: string;
  street: string;
  cep: string;
  neighborhood: string;
  number: string;
  addressComplement: string;
  productList: Product[];
  value: number;
  state: string;
  city: string;
}

const initialValues: InitialValuesProps = {
  name: "",
  email: "",
  cpf: "",
  store: "",
  phone: "",
  birthDate: "",
  street: "",
  cep: "",
  neighborhood: "",
  number: "",
  addressComplement: "",
  productList: [],
  value: 0,
  state: "",
  city: "",
};

export const validationSchemaStep1 = Yup.object().shape({
  name: Yup.string().required("Nome é obrigatório"),
  birthDate: Yup.string()
    .matches(/^\d{2}\/\d{2}\/\d{4}$/, "Data de nascimento inválida") // validar mes e dia, etc
    .required("Data de nascimento é obrigatória"),
  cpf: Yup.string()
    .matches(/^\d{3}\.\d{3}\.\d{3}\-\d{2}$/, "CPF inválido")
    .required("CPF é obrigatório"),
  email: Yup.string()
    .email("Digite um e-mail válido")
    .required("E-mail é obrigatório"),
  phone: Yup.string()
    .matches(/^\(\d{2}\)\s\d{5}-\d{4}$/, "Telefone inválido")
    .required("Telefone é obrigatório"),
});

export const validationSchemaStep2 = Yup.object().shape({
  street: Yup.string().required("Rua é obrigatória"),
  cep: Yup.string()
    .matches(/^\d{5}-\d{3}$/, "CEP inválido") // validar mes e dia, etc
    .required("CEP é obrigatório"),
  neighborhood: Yup.string().required("Bairro é obrigatório"),
  number: Yup.string().required("Número é obrigatório"),
  phone: Yup.string()
    .matches(/^\(\d{2}\)\s\d{5}-\d{4}$/, "Telefone inválido")
    .required("Telefone é obrigatório"),
  city: Yup.string().required("Cidade é obrigatória"),
  state: Yup.string().required("Estado é obrigatório"),
});

export const validationSchemaStep3 = Yup.object().shape({
  store: Yup.string().required("Loja é obrigatória"),
  productList: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required("Nome do produto é obrigatório"),
      quantity: Yup.number().required("A quantidade é obrigatória").min(1),
      price: Yup.number().required("Valor é obrigatório").min(0),
    })
  ),
});

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Nome é obrigatório"),
  email: Yup.string()
    .email("Digite um e-mail válido")
    .required("E-mail é obrigatório"),
  cpf: Yup.string()
    .matches(/^\d{3}\.\d{3}\.\d{3}\-\d{2}$/, "CPF inválido")
    .required("CPF é obrigatório"),
  store: Yup.string().required("Loja é obrigatória"),
  value: Yup.string().required("Valor é obrigatório"),
  addressComplement: Yup.string().optional(),
});

export { initialValues, validationSchema };
